import createBreakpoint from 'shared-tokens/utils/breakpoints';

const brS = createBreakpoint('s');

export const mainCls = 'dialog-confirm';

export default {
  [mainCls]: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 100,
    opacity: 0,
    '-webkit-transition': 'opacity 0.3s linear',
    transition: 'opacity 5s linear',
  },
  [`${mainCls}--fixed`]: {
    position: 'fixed',
    opacity: 1,
  },
  [`${mainCls}--ovrl`]: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    opacity: 0.7,
    background: '#39434e',
    zIndex: 101,
    cursor: 'pointer',
  },
  [`${mainCls}__conf`]: {
    height: '130px',
    background: '#fff',
    borderRadius: '6px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '270px',
    '-webkit-transform': 'translate(-50%, calc(-50% + 100px))',
    opacity: 0,
    zIndex: 102,
    pointerEvents: 'none',
  },
  [`${mainCls}__conf__text`]: {
    height: '100%',
    '&--blk': {
      display: 'block',
    },
  },
  [`${mainCls}__conf__btns`]: {
    borderTop: '1px solid #e4e4e4',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '10px',
      height: '24px',
      left: '50%',
      width: '1px',
      background: '#e4e4e4',
    },
  },
  [`${mainCls}__conf__btn`]: {
    width: '50%',
    height: '45px',
    background: 'transparent',
    border: '0 none',
  },
  [`${mainCls}__conf--up`]: {
    '-webkit-transform': 'translate(-50%, -50%)',
    transform: 'translate(-50%, -50%)',
    opacity: 1,
    pointerEvents: 'all',
    
  },
};
